export const setDefaultCoin = (defaultCoin) => ({
    type: "SET_DEFAULT_COIN",
    payload: { defaultCoin },
  });
  